export interface StoreTimeSchedule {
	dayOfWeek: string
	timeList: {
		closeHour: string
		openHour: string
	}[]
}

export interface Coordinates {
	lat: number
	lng: number
}

export interface StoreDetails {
	timeSchedule: StoreTimeSchedule[]
	type?: string
	phone?: string
	isCorner?: boolean
	urlVisitStore?: string | null
	showVisitStore?: boolean
	sizes?: string[]
	sizesIds?: {
		id: string
		name: string
	}[]
	tiposVenta?: string[]
}
export interface Store {
	id: string
	addresses: {
		address: string
		streetAddress?: string
		postalCode: string
		city: string
		shoppingCenter: string | null
		coordinates: Coordinates & {
			distance: number
		}
	}
	collections: string[]
	details?: StoreDetails
}

export interface AddressInfo {
	address: string
	postalCode: string | undefined
	cityName: string | undefined
}

export interface Location {
	coordinates?: Coordinates
	addressInfo?: AddressInfo
}

export interface LatestSearchedLocation {
	location: Location
	searchInput: string
}

export interface DataFromDroppoint {
	deliveryPointId: string
	name: string
	address: {
		streetAddress: string
		city: string
		postalCode: string
		coordinate: {
			latitude: number
			longitude: number
		}
	}
	timeSchedule: StoreTimeSchedule[]
	type: string
}

export enum MAP_TYPE {
	GARMENT_STORES = 'garmentStores',
	STORES = 'stores',
	DROPPOINTS = 'dropPoints',
}

export enum StoreType {
	Packstation = 'Packstation',
}
